module.exports = __webpack_public_path__ + "img/bg_past_lv_1.83017762.jpg";